import React from "react";
import styled from "styled-components";
import { FaBug, FaCoins, FaUsers } from "react-icons/fa";

const Section = styled.section`
  padding: 4rem 2rem;
  background: #1a1a1a;
  text-align: center;
`;

const Title = styled.h2`
  font-size: 2.5rem;
  margin-bottom: 2rem;
  color: ${({ theme }) => theme.secondary};
`;

const FeatureGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  justify-content: center;
`;

const FeatureCard = styled.div`
  background: ${({ theme }) => theme.glass};
  padding: 2rem;
  border-radius: 12px;
  width: 280px;
  box-shadow: 0 0 10px ${({ theme }) => theme.primary};
  color: #eee;
`;

const Icon = styled.div`
  font-size: 2rem;
  margin-bottom: 1rem;
`;

export default function Features() {
  return (
    <Section>
      <Title>Features</Title>
      <FeatureGrid>
        <FeatureCard>
          <Icon>
            <FaBug />
          </Icon>
          <h3>Post Code Issues</h3>
          <p>Struggling with bugs? Post real code problems.</p>
        </FeatureCard>
        <FeatureCard>
          <Icon>
            <FaCoins />
          </Icon>
          <h3>Offer Rewards</h3>
          <p>Offer coins/cash to get your issues solved fast.</p>
        </FeatureCard>
        <FeatureCard>
          <Icon>
            <FaUsers />
          </Icon>
          <h3>Get Hired</h3>
          <p>Top solvers build a public portfolio + get offers.</p>
        </FeatureCard>
      </FeatureGrid>
    </Section>
  );
}
